import { createFileRoute } from '@tanstack/react-router'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { NotFoundContent } from '@/components/NotFoundContent'

export const Route = createFileRoute('/$')({
  component: NotFoundPage,
})

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1">
        <NotFoundContent />
      </main>
      <Footer />
    </div>
  )
}
